import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import './BotDetails.css';
import mobilePhoto from '../../Assets/mobile.png'
import { useNavigate } from "react-router-dom";
import {
  FaLink, FaQuestionCircle, FaHeadset, FaTicketAlt, FaChartBar, FaInbox, FaRobot,
  FaUserAlt,
  FaRegQuestionCircle,
  FaComments,
  FaSmile,
  FaBrain,
  FaWhatsapp,
  FaTelegramPlane,
  FaExternalLinkAlt
} from 'react-icons/fa';
import { MdSettings, MdOutlineIntegrationInstructions, MdSupportAgent, MdAccessTime } from 'react-icons/md';
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import { FiMove, FiMoreVertical, FiPlus, FiEdit2, FiTrash2 } from "react-icons/fi";
import SourcesTrainer from "./SourcesTrainer";
import ChatPreview from "./ChatPreview";
import Inbox from "./Inbox";
import Analytics from "./Analytics";
import IntegrationsSection from "./IntegrationsSection";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import xenaChatLogo from "../../Assets/logo-update.png";
const API_BASE_URL = process.env.REACT_APP_BACKEND_API_URL;
const PYTHON_BASE_URL = process.env.REACT_APP_PYTHON_URL;
console.log("ENV PYTHON URL:", PYTHON_BASE_URL);
/* 🔗 Messaging app constants (configure once, no per-user phone input) */
const WHATSAPP_BUSINESS_NUMBER = "15556366543";
const TELEGRAM_BOT_USERNAME = "YourTelegramBot";
/* ---- Add this at the top of BotDetails.jsx (under imports) ---- */
const PLAN_MODEL_ACCESS = {
  none: ["gpt-4o-mini"],
  starter: ["gpt-4o-mini"],
  pro: ["gpt-4o-mini", "gpt-4o", "gpt-4.1", "o3-mini", "o4-mini"],
  advanced: ["gpt-4o-mini", "gpt-4o", "gpt-4.1", "o3-mini", "o4-mini", "o3", "gpt-5"],
  enterprise: ["gpt-4o-mini", "gpt-4o", "gpt-4.1", "o3-mini", "o4-mini", "o3", "gpt-5"],
};
// Mirrors Dashboard's PLAN_SPECS.uploadCharLimit
const PLAN_UPLOAD_LIMITS = {
  none: 0,
  starter: 10_000_000,
  pro: 50_000_000,
  advanced: 100_000_000,
  enterprise: Number.POSITIVE_INFINITY,
};

function planKeyFromName(name) {
  if (!name) return "none";
  const n = String(name).trim().toLowerCase();
  if (n.includes("starter")) return "starter";
  if (n.includes("professional") || n === "pro") return "pro";
  if (n.includes("advanced")) return "advanced";
  if (n.includes("enterprise")) return "enterprise";
  return "none";
}
function Shimmer({ style = {} }) {
  return <div className="shimmer" style={style} />;
}

function Line({ w = "100%", h = 12, r = 6, style = {} }) {
  return <div className="skel-line" style={{ width: w, height: h, borderRadius: r, ...style }} />;
}

function Circle({ size = 48, style = {} }) {
  return <div className="skel-circle" style={{ width: size, height: size, borderRadius: size / 2, ...style }} />;
}

function BotDetailsSkeleton() {
  return (
    <div className="bot-page">
      <aside className="bot-sidebar">
        <Line w="60%" h={20} style={{ marginBottom: 16 }} />
        <ul className="bot-sidebar-menu">
          {Array.from({ length: 7 }).map((_, i) => (
            <li key={i} className="skel-li">
              <Circle size={18} />
              <Line w="70%" h={12} />
            </li>
          ))}
        </ul>
        <div className="bot-sidebar-footer">
          <Line w="80%" h={36} r={12} />
        </div>
      </aside>

      <main className="bot-details-container fade-in">
        {/* Header strip */}
        <div className="skel-header">
          <Line w="30%" h={22} />
          <div style={{ display: "flex", gap: 8 }}>
            <Line w={90} h={32} r={10} />
            <Line w={120} h={32} r={10} />
          </div>
        </div>

        {/* Tabs placeholder */}
        <div className="skel-tabs">
          {["General", "Appearance", "Messaging", "Starter", "Email", "Usage", "Form", "Hours"].map((t, idx) => (
            <Line key={idx} w={100} h={28} r={8} />
          ))}
        </div>

        {/* Content cards */}
        <div className="skel-cards">
          {Array.from({ length: 3 }).map((_, i) => (
            <div key={i} className="skel-card">
              <Line w="40%" h={16} style={{ marginBottom: 12 }} />
              <Line w="100%" h={42} r={10} style={{ marginBottom: 10 }} />
              <Line w="85%" h={42} r={10} />
            </div>
          ))}
        </div>
      </main>
    </div>
  );
}


const BotDetails = () => {
  const { botId } = useParams();
  const [bot, setBot] = useState(null);
  const [user, setUser] = useState(null);
  const [trainingOpen, setTrainingOpen] = useState(true);
  const [selectedSection, setSelectedSection] = useState("Settings"); // default to "Settings"
  const [settingsTab, setSettingsTab] = useState("General"); // default sub-tab
  const navigate = useNavigate();
  const [originalBot, setOriginalBot] = useState(null);
  const [starterQuestions, setStarterQuestions] = useState([]);
  const [isAddingQuestion, setIsAddingQuestion] = useState(false);
  const [newQuestion, setNewQuestion] = useState("");
  const [newAnswer, setNewAnswer] = useState("");
  const [supportRoutes, setSupportRoutes] = useState([]);
  const [editIndex, setEditIndex] = useState(null);
  // add near other useState calls
  const [apiBase, setApiBase] = useState(PYTHON_BASE_URL);

  const [connectEmail, setConnectEmail] = useState("");
  const [connectBotName, setConnectBotName] = useState("");
  // --- Embed generator state ---
  const [embedTab, setEmbedTab] = useState("JavaScript");
  const [embedApiBase, setEmbedApiBase] = useState(PYTHON_BASE_URL);
  const [embedEmail, setEmbedEmail] = useState("");
  const [embedBotName, setEmbedBotName] = useState("");
  const [widgetTitle, setWidgetTitle] = useState("Chat with us");
  const [widgetAccent, setWidgetAccent] = useState("#2563eb");
  const [widgetPosition, setWidgetPosition] = useState("right"); // left|right
  const [widgetHeight, setWidgetHeight] = useState(480);
  const [widgetWidth, setWidgetWidth] = useState(340);
  const [workingTab, setWorkingTab] = useState("Details");

  const AI_MODELS = [
    { id: "gpt-5", label: "GPT-5 (latest, most advanced)" },
    { id: "gpt-4.1", label: "GPT-4.1 (high quality reasoning)" },
    { id: "gpt-4o", label: "GPT-4o (fast multimodal)" },
    { id: "gpt-4o-mini", label: "GPT-4o mini (lightweight, low cost)" },
    { id: "o3", label: "o3 (reasoning model)" },
    { id: "o3-mini", label: "o3-mini (fast reasoning, lower cost)" },
    { id: "o4-mini", label: "o4-mini (optimized reasoning)" },
  ];
  // 🔐 Plan-based model access
  const currentPlanKey = user?.billing?.planId?.toLowerCase() || "none";
  const hasAnyPlan = currentPlanKey !== "none";
  const allowedModelIds = PLAN_MODEL_ACCESS[currentPlanKey] || [];
  const uploadCharLimit = user?.billing?.limits?.uploadChars ?? 0;
  const effectiveAIModels = hasAnyPlan
    ? AI_MODELS.filter((m) => allowedModelIds.includes(m.id))
    : AI_MODELS.filter((m) => m.id === "gpt-4o-mini"); // free tier fallback

  const canUseAgenticWorkflows =
    currentPlanKey === "advanced" || currentPlanKey === "enterprise";

  useEffect(() => {
    const fetchUser = async () => {
      try {
        const token = JSON.parse(localStorage.getItem("user"))?.token;
        if (!token) return;

        const res = await fetch(`${API_BASE_URL}/api/auth/me`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });

        if (!res.ok) throw new Error("Failed to fetch user");

        const freshUser = await res.json();
        setUser(freshUser);
      } catch (err) {
        console.error("Failed to load user:", err);
      }
    };

    fetchUser();
  }, []);
  useEffect(() => {
    if (!bot) return;
    const allowed = allowedModelIds.length
      ? allowedModelIds
      : ["gpt-4o-mini"];

    if (bot.aiModel && !allowed.includes(bot.aiModel)) {
      const fallback = allowed[0] || "gpt-4o-mini";

      if (bot.aiModel !== fallback) {
        setBot((prev) => ({ ...prev, aiModel: fallback }));
      }
    }
  }, [bot, allowedModelIds]);


  useEffect(() => {
    fetch(`${API_BASE_URL}/api/auth/bots/${botId}`)
      .then((res) => res.json())
      .then((data) => setBot({...data, timezone: data.timezone || "Asia/Kolkata", }))
      .catch((err) => console.error("Error loading bot details:", err));
  }, [botId]);
  useEffect(() => {
    if (!bot) return;
    if (!bot.brandingImageURL) {
      (async () => {
        try {
          const url = await uploadBrandingLogoToCloudinary();
          setBot((prev) => ({
            ...prev,
            brandingImageURL: url,
          }));
        } catch (err) {
          console.error("Branding auto-upload failed:", err);
        }
      })();
    }
  }, [bot]);


  useEffect(() => {
    if (bot?.starterQuestions) {
      setStarterQuestions(bot.starterQuestions);
    }
  }, [bot]);
  // Set original copy for discard
  useEffect(() => {
    if (bot) setOriginalBot(bot);
  }, [bot]);
  useEffect(() => {
    if (bot && !bot.aiModel) {
      setBot({ ...bot, aiModel: "gpt-4o-mini" });
    }
  }, [bot]);
  useEffect(() => {
    const allowed =
      user?.managePlanAddOns?.dummyFlagPayment === true &&
      user?.managePlanAddOns?.isHideBranding === true;

    if (bot && !allowed && bot.hideBranding !== false) {
      setBot(prev => ({ ...prev, hideBranding: false }));
    }
  }, [user, bot]);
  const handleDragEnd = (result) => {
    if (!result.destination) return;
    const reordered = Array.from(starterQuestions);
    const [movedItem] = reordered.splice(result.source.index, 1);
    reordered.splice(result.destination.index, 0, movedItem);
    setStarterQuestions(reordered);
  };
  const widgetIcons = [
    { icon: <FaRobot />, key: "robot" },
    { icon: <FaUserAlt />, key: "user" },
    { icon: <FaRegQuestionCircle />, key: "question" },
    { icon: <FaHeadset />, key: "headset" },
    { icon: <FaBrain />, key: "brain" },
    { icon: <MdAccessTime />, key: "time" },
    { icon: <FaComments />, key: "chat" },
    { icon: <MdSupportAgent />, key: "support" },
    { icon: <FaSmile />, key: "smile" },
  ];
  const toggleSettings = [
    {
      key: 'followUps',
      label: 'Suggest Follow Up Questions',
      value: 'If enabled, we will suggest 2 new follow up questions from your knowledge base',
    },
    {
      key: 'allowImageUsage',
      label: 'Allow Image Usage',
      value: 'Allows the bot to use the scraped images for training and response generation',
    },
    {
      key: 'showSources',
      label: 'Show sources with the response',
      value: 'Hide/Show sources along with responses',
    },
    {
      key: 'chatFeedback',
      label: 'Post chat feedback',
      value: 'Hide/Show post chat feedback',
    },
    {
      key: 'multilingual',
      label: 'Multilingual Support',
      value: 'If disabled, the bot will stick to the selected language',
    },
    {
      key: 'showWelcome',
      label: 'Show floating welcome message',
      value: 'Toggle visibility of the Welcome Message',
    },
  ];
  const handleSave = async () => {
    const toastId = toast.loading("Saving changes…");

    try {
      const token = JSON.parse(localStorage.getItem("user"))?.token;
      if (!token) throw new Error("Not authenticated");

      let brandingURL = bot.brandingImageURL;

      // 🚀 Upload branding logo ONLY on Save
      if (!brandingURL) {
        toast.update(toastId, { render: "Uploading branding…", isLoading: true });
        brandingURL = await uploadBrandingLogoToCloudinary();
      }

      const payload = {
        ...bot,
        timezone: bot.timezone || "Asia/Kolkata",
        brandingImageURL: brandingURL,
        botAvatarURL: bot.botAvatarURL || "",
      };

      toast.update(toastId, { render: "Saving settings…", isLoading: true });

      const res = await fetch(`${API_BASE_URL}/api/auth/bots/${botId}`, {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify(payload),
      });

      if (!res.ok) {
        const msg = await res.text();
        throw new Error(msg || `HTTP ${res.status}`);
      }

      const data = await res.json();
      setBot(data);
      setOriginalBot(data);

      toast.update(toastId, {
        render: "Changes saved successfully 🎉",
        type: "success",
        isLoading: false,
        autoClose: 2500,
      });
    } catch (err) {
      console.error("Save failed:", err);

      toast.update(toastId, {
        render: err.message || "Failed to save changes",
        type: "error",
        isLoading: false,
        autoClose: 3500,
      });
    }
  };


  // ...

  const handleIntegrationRequest = (channel) => {
    // channel: "whatsapp" | "telegram"
    // We send them to the existing bookdemo page with a query param
    navigate(`/bot/${botId}/bookdemo?channel=${channel}`);
  };

  // ...
  const handleDiscard = () => {
    if (originalBot) setBot(originalBot);
  };
  useEffect(() => {
    if (bot) {
      if (bot.email) setConnectEmail(bot.email);
      if (bot.botName) setConnectBotName(bot.botName);
    }
  }, [bot]);
  useEffect(() => {
    if (!bot) return;


    // Connect tab defaults
    if (bot.email) setConnectEmail(bot.email);
    if (bot.botName) setConnectBotName(bot.botName);

    // Integrations tab defaults — always reflect what's saved in Settings
    setEmbedEmail(bot.email || "");
    setEmbedBotName(bot.botName || "");
    setWidgetTitle(bot.widgetName || bot.botName || "Chat with us");
    setWidgetAccent(bot.accentColor || "#2563eb");
    setWidgetPosition(bot.widgetPosition || "right");


  }, [bot]);
  useEffect(() => {
    console.log("PYTHON_BASE_URL:", PYTHON_BASE_URL);
  }, []);

  useEffect(() => {
    if (bot && Array.isArray(bot.supportEmails)) {
      setSupportRoutes(bot.supportEmails);
    } else {
      setSupportRoutes([]);
    }
  }, [bot]);


  const syncSupportRoutes = (routes) => {
    setSupportRoutes(routes);
    setBot((prev) => (prev ? { ...prev, supportEmails: routes } : prev));
  };

  const copyToClipboard = async (txt) => {
    try {
      await navigator.clipboard.writeText(txt);
      toast.success("Copied to clipboard");
    } catch {
      toast.error("Copy failed. Select and copy manually.");
    }
  };

  const genJsSnippet = () => {
    const base = (embedApiBase || "").replace(/\/$/, "");
    const emailEnc = encodeURIComponent(embedEmail || "");
    const botEnc = encodeURIComponent(embedBotName || "");
    const title = widgetTitle || "XenaChat";
    const accent = widgetAccent || "#2563eb";
    const width = Number(widgetWidth) || 340;
    const height = Number(widgetHeight) || 480;
    const pos = widgetPosition === "left" ? "left" : "right";

    // Appearance
    const subheading = bot?.subheading || "";
    const widgetIcon = bot?.widgetIcon || "robot";
    const inputPlaceholder = bot?.inputPlaceholder || "";
    const hideBranding = !!bot?.hideBranding;
    const isWidgetOpen = !!bot?.isWidgetOpen;
    const showStarters = bot?.showStarterQuestions !== false;
    const brandingImage = bot?.brandingImageURL || "";
    const botAvatar = bot?.botAvatarURL || "";

    // Messaging
    const aiModel = bot?.aiModel || "gpt-4o-mini";
    const responseLength = bot?.responseLength || "short";
    const conversationalMode = !!bot?.conversationalMode;
    const strictFaq = !!bot?.strictFaq;

    const followUps = !!bot?.followUps;
    const allowImageUsage = !!bot?.allowImageUsage;
    const showSources = !!bot?.showSources;
    const chatFeedback = !!bot?.chatFeedback;
    const multilingual = !!bot?.multilingual;
    const showWelcome = !!bot?.showWelcome;

    const welcomeMessage = bot?.welcomeMessage || "";
    const noSourceMessage = bot?.noSourceMessage || "";
    const serverErrorMessage = bot?.serverErrorMessage || "";

    // Usage & security
    const messageLimit = Number(bot?.messageLimit ?? 0);
    const limitType = bot?.limitType || "per day";
    const limitWarning = bot?.limitWarning || "";
    const rateLimit = Number(bot?.rateLimit ?? 0);
    const blockMaskedIPs = !!bot?.blockMaskedIPs;

    // NEW: User form & Captcha
    const enableUserForm = !!bot?.enableUserForm;
    const enableCaptcha = !!bot?.enableCaptcha;

    // NEW: Working hours
    const enableWorkingHours = !!bot?.enableWorkingHours;
    const timezone = bot?.timezone || "Asia/Kolkata";
    const workingHoursObj = bot?.workingHours || {}; // object structure from settings
    const workingHoursEnc = encodeURIComponent(JSON.stringify(workingHoursObj));

    // Build query string (include working hours)
    const qs =
      "email=" + emailEnc +
      "&bot=" + botEnc +
      "&title=" + encodeURIComponent(title) +
      "&accent=" + encodeURIComponent(accent) +
      "&width=" + encodeURIComponent(String(width)) +
      "&height=" + encodeURIComponent(String(height)) +
      "&pos=" + encodeURIComponent(pos) +
      "&subheading=" + encodeURIComponent(subheading) +
      "&widgetIcon=" + encodeURIComponent(widgetIcon) +
      "&inputPlaceholder=" + encodeURIComponent(inputPlaceholder) +
      "&hideBranding=" + (hideBranding ? "1" : "0") +
      "&isOpen=" + (isWidgetOpen ? "1" : "0") +
      "&showStarters=" + (showStarters ? "1" : "0") +
      "&brandingImageURL=" + encodeURIComponent(brandingImage) +
      "&botAvatarURL=" + encodeURIComponent(botAvatar) +

      // Messaging
      "&aiModel=" + encodeURIComponent(aiModel) +
      "&responseLength=" + encodeURIComponent(responseLength) +
      "&conversationalMode=" + (conversationalMode ? "1" : "0") +
      "&strictFaq=" + (strictFaq ? "1" : "0") +
      "&followUps=" + (followUps ? "1" : "0") +
      "&allowImageUsage=" + (allowImageUsage ? "1" : "0") +
      "&showSources=" + (showSources ? "1" : "0") +
      "&chatFeedback=" + (chatFeedback ? "1" : "0") +
      "&multilingual=" + (multilingual ? "1" : "0") +
      "&showWelcome=" + (showWelcome ? "1" : "0") +
      "&welcomeMessage=" + encodeURIComponent(welcomeMessage) +
      "&noSourceMessage=" + encodeURIComponent(noSourceMessage) +
      "&serverErrorMessage=" + encodeURIComponent(serverErrorMessage) +
      // Usage/Security
      "&messageLimit=" + encodeURIComponent(String(messageLimit)) +
      "&limitType=" + encodeURIComponent(limitType) +
      "&limitWarning=" + encodeURIComponent(limitWarning) +
      "&rateLimit=" + encodeURIComponent(String(rateLimit)) +
      "&blockMaskedIPs=" + (blockMaskedIPs ? "1" : "0") +
      // NEW: User form & Captcha
      "&enableUserForm=" + (enableUserForm ? "1" : "0") +
      "&enableCaptcha=" + (enableCaptcha ? "1" : "0") +
      // NEW: Working hours + timezone + JSON-encoded schedule
      "&enableWorkingHours=" + (enableWorkingHours ? "1" : "0") +
      "&timezone=" + encodeURIComponent(timezone) +
      "&workingHours=" + workingHoursEnc;

    return `<!-- XenaChat inline widget -->
<script id="xenachat-script">
(function(){
  if (window.__xenachat_inited) return; 
  window.__xenachat_inited = true;

  var API_BASE="${base}";
  var ACCENT="${accent}";
  var WIDTH=${width};
  var HEIGHT=${height};
  var POS="${pos}";

  try { var old = document.getElementById("xenachat-root"); if (old) old.remove(); } catch(e){}

  // Styles
  var style = document.createElement('style');
  style.textContent =
    ".xc-btn{position:fixed;"+POS+":20px;bottom:20px;z-index:2147483647;background:"+ACCENT+";color:#fff;border:none;border-radius:999px;padding:12px 16px;font:600 14px system-ui;box-shadow:0 6px 16px rgba(0,0,0,.2);cursor:pointer}" +
    ".xc-iframe-wrap{position:fixed;"+POS+":20px;bottom:72px;z-index:2147483647;width:"+WIDTH+"px;height:"+HEIGHT+"px;border-radius:12px;box-shadow:0 10px 30px rgba(0,0,0,.25);overflow:hidden;background:#fff;display:none;border:1px solid #e5e7eb}" +
    ".xc-iframe-wrap.open{display:block}";
  document.head.appendChild(style);

  // Button
  var btn = document.createElement('button');
  btn.className = "xc-btn";
  btn.textContent = "Chat";
  document.body.appendChild(btn);

  // Panel + Iframe
  var wrap = document.createElement('div');
  wrap.id = "xenachat-root";
  wrap.className = "xc-iframe-wrap";

  var iframe = document.createElement('iframe');
  iframe.src = API_BASE + "/widget?${qs}";
  iframe.style.cssText = "width:100%;height:100%;border:0";
  iframe.setAttribute("title","XenaChat");
  iframe.setAttribute("aria-label","Chat widget");

  wrap.appendChild(iframe);
  document.body.appendChild(wrap);

  ${isWidgetOpen ? "wrap.classList.add('open');" : ""}

  btn.addEventListener('click', function(){
    wrap.classList.toggle('open');
  });
})();
<\/script>`;
  };
  const genIframeSnippet = () => {
    const base = (embedApiBase || "").replace(/\/$/, "");
    const email = encodeURIComponent(embedEmail || "");
    const botEnc = encodeURIComponent(embedBotName || "");
    const title = encodeURIComponent(widgetTitle || "Chat with us");
    const w = Number(widgetWidth) || 340;
    const h = Number(widgetHeight) || 480;
    const enableUserForm = bot?.enableUserForm ? "1" : "0";
    const enableCaptcha = bot?.enableCaptcha ? "1" : "0";

    // Working hours payload (JSON)
    const workingHoursPayload = encodeURIComponent(JSON.stringify(bot?.workingHours || {}));
    const enableWorkingHours = bot?.enableWorkingHours ? "1" : "0";
    const timezone = encodeURIComponent(bot?.timezone || "Asia/Kolkata");

    const qs =
      `email=${email}` +
      `&bot=${botEnc}` +
      `&title=${title}` +
      `&accent=${encodeURIComponent(widgetAccent || "#2563eb")}` +
      `&pos=${encodeURIComponent(widgetPosition || "right")}` +
      `&width=${encodeURIComponent(String(w))}` +
      `&height=${encodeURIComponent(String(h))}` +
      // Appearance + Messaging + usage (kept as before)
      `&subheading=${encodeURIComponent(bot?.subheading || "")}` +
      `&widgetIcon=${encodeURIComponent(bot?.widgetIcon || "robot")}` +
      `&inputPlaceholder=${encodeURIComponent(bot?.inputPlaceholder || "")}` +
      `&hideBranding=${bot?.hideBranding ? "1" : "0"}` +
      `&isOpen=${bot?.isWidgetOpen ? "1" : "0"}` +
      `&showStarters=${bot?.showStarterQuestions !== false ? "1" : "0"}` +
      `&aiModel=${encodeURIComponent(bot?.aiModel || "gpt-4o-mini")}` +
      `&responseLength=${encodeURIComponent(bot?.responseLength || "short")}` +
      `&conversationalMode=${bot?.conversationalMode ? "1" : "0"}` +
      `&strictFaq=${bot?.strictFaq ? "1" : "0"}` +
      `&followUps=${bot?.followUps ? "1" : "0"}` +
      `&allowImageUsage=${bot?.allowImageUsage ? "1" : "0"}` +
      `&showSources=${bot?.showSources ? "1" : "0"}` +
      `&chatFeedback=${bot?.chatFeedback ? "1" : "0"}` +
      `&multilingual=${bot?.multilingual ? "1" : "0"}` +
      `&showWelcome=${bot?.showWelcome ? "1" : "0"}` +
      `&welcomeMessage=${encodeURIComponent(bot?.welcomeMessage || "")}` +
      `&noSourceMessage=${encodeURIComponent(bot?.noSourceMessage || "")}` +
      `&serverErrorMessage=${encodeURIComponent(bot?.serverErrorMessage || "")}` +
      "&brandingImageURL=" + encodeURIComponent(bot?.brandingImageURL || "") +
      "&botAvatarURL=" + encodeURIComponent(bot?.botAvatarURL || "") +


      // Usage/Security
      `&messageLimit=${encodeURIComponent(String(bot?.messageLimit ?? 0))}` +
      `&limitType=${encodeURIComponent(bot?.limitType || "per day")}` +
      `&limitWarning=${encodeURIComponent(bot?.limitWarning || "")}` +
      `&rateLimit=${encodeURIComponent(String(bot?.rateLimit ?? 0))}` +
      `&blockMaskedIPs=${bot?.blockMaskedIPs ? "1" : "0"}` +
      `&enableUserForm=${enableUserForm}` +
      `&enableCaptcha=${enableCaptcha}` +
      // NEW: Working hours
      `&enableWorkingHours=${enableWorkingHours}` +
      `&timezone=${timezone}` +
      `&workingHours=${workingHoursPayload}`;

    const src = `${base}/widget?${qs}`;

    return `<iframe
  src="${src}"
  title="XenaChat"
  style={{
    width: ${w},
    height: ${h},
    border: "1px solid rgba(229, 231, 235, 1)",
    borderRadius: 12,
    overflow: "hidden"
  }}
  loading="lazy"
  referrerpolicy="no-referrer-when-downgrade"
  allow="clipboard-write; autoplay; encrypted-media"
></iframe>`;
  };

  const resolvedBotUI = React.useMemo(() => {
    if (!bot) {
      return {
        botName: "XenaChat",
        botAvatarURL: "",
        brandingImageURL: "",
        hideBranding: false,
        accentColor: "#2563eb",
        widgetPosition: "right",
        subheading: "",
        inputPlaceholder: "",
        isWidgetOpen: false,
        showStarterQuestions: false,
      };
    }

    const canHideBranding =
      user?.managePlanAddOns?.dummyFlagPayment === true &&
      user?.managePlanAddOns?.isHideBranding === true;
    const hideBranding = canHideBranding && bot.hideBranding === true;

    return {
      botName: bot.widgetName || bot.botName || "XenaChat",
      botAvatarURL: bot.botAvatarURL || "",
      brandingImageURL: hideBranding ? "" : bot.brandingImageURL || "",
      hideBranding,
      accentColor: bot.accentColor || "#2563eb",
      widgetPosition: bot.widgetPosition || "right",
      subheading: bot.subheading || "",
      inputPlaceholder: bot.inputPlaceholder || "",
      isWidgetOpen: bot.isWidgetOpen || false,
      showStarterQuestions: bot.showStarterQuestions || false,
    };
  }, [bot, user]);



  const genChatServiceSnippet = () => {
    const apiBase = process.env.REACT_APP_BACKEND_API_URL;
    const apiKey = bot?.apiKey;

    const uiConfig = {
      botName: resolvedBotUI.botName,
      subheading: bot.subheading || "",
      botAvatarURL: resolvedBotUI.botAvatarURL,
      brandingImageURL: resolvedBotUI.brandingImageURL,
      hideBranding: resolvedBotUI.hideBranding,
      accentColor: resolvedBotUI.accentColor,
      widgetPosition: resolvedBotUI.widgetPosition,
      inputPlaceholder: resolvedBotUI.inputPlaceholder || "Type your message…",
      starterQuestions: (bot.starterQuestions || []).map(q => ({ question: q.question, answer: q.answer })),
      isWidgetOpen: resolvedBotUI.isWidgetOpen,
      showStarterQuestions: resolvedBotUI.showStarterQuestions,
    };

    return `// src/services/chatService.js
import axios from "axios";

/**
 * XenaChat REST Client
 * Bot: ${bot.botName}
 */

const API_BASE = "${apiBase}";
const API_KEY = "${apiKey}";

export const DEFAULT_BOT_UI = ${JSON.stringify(uiConfig, null, 2)};

export async function sendMessage(message, meta = {}) {
  const res = await axios.post(
    \`\${API_BASE}/api/chat\`,
    { message, ...meta },
    {
      headers: {
        Authorization: \`Bearer \${API_KEY}\`,
        "Content-Type": "application/json",
      },
    }
  );

  return {
    ...res.data,
    ui: {
      ...DEFAULT_BOT_UI,
      ...(res.data.ui || {}),
    },
  };
}
`;
  };


  const genSimpleChatBotSnippet = () => {
    return `// src/components/SimpleChatBot.jsx
import { useState } from "react";
import { sendMessage, DEFAULT_BOT_UI } from "../services/chatService";

export default function SimpleChatBot() {
  const [messages, setMessages] = useState([
    { role: "bot", text: "Hi 👋 How can I help you?" },
  ]);
  const [input, setInput] = useState("");
  const [loading, setLoading] = useState(false);
  const [ui, setUI] = useState(DEFAULT_BOT_UI);
  const [open, setOpen] = useState(DEFAULT_BOT_UI.isWidgetOpen);

  const handleSend = async (text) => {
    if (!text.trim()) return;

    setMessages(prev => [...prev, { role: "user", text }]);
    setInput("");
    setLoading(true);

    try {
      const res = await sendMessage(text);
      if (res.ui) setUI(res.ui);

      setMessages(prev => [...prev, { role: "bot", text: res.answer }]);
    } catch {
      setMessages(prev => [...prev, { role: "bot", text: "⚠️ Something went wrong." }]);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      {/* Floating Button */}
      <button
        style={{
          ...styles.fab,
          background: ui.accentColor,
          ...(ui.widgetPosition === "left" ? { left: 20 } : { right: 20 }),
        }}
        onClick={() => setOpen(o => !o)}
      >
        Chat
      </button>

      {/* Widget */}
      {open && (
        <div
          style={{
            ...styles.container,
            ...(ui.widgetPosition === "left" ? { left: 20 } : { right: 20 }),
          }}
        >
          {/* Header */}
          <div style={{ ...styles.header, background: ui.accentColor }}>
            {ui.botAvatarURL && (
              <img src={ui.botAvatarURL} style={styles.avatar} />
            )}
            <div>
              <div style={styles.botName}>{ui.botName}</div>
              {ui.subheading && (
                <div style={styles.subheading}>{ui.subheading}</div>
              )}
            </div>
          </div>

          {/* Messages */}
          <div style={styles.messages}>
            {messages.map((m, i) => (
              <div
                key={i}
                style={{
                  ...styles.message,
                  alignSelf: m.role === "user" ? "flex-end" : "flex-start",
                  background: m.role === "user" ? ui.accentColor : "#e5e7eb",
                  color: m.role === "user" ? "#fff" : "#000",
                }}
              >
                {m.text}
              </div>
            ))}
            {loading && <div style={styles.typing}>Bot is typing…</div>}
          </div>

          {/* Starter Questions */}
          {ui.showStarterQuestions && ui.starterQuestions?.length > 0 && (
            <div style={styles.starters}>
              {ui.starterQuestions.map((q, i) => (
                <button
                  key={i}
                  style={{ ...styles.starterChip, borderColor: ui.accentColor }}
                  onClick={() => handleSend(q.question)}
                >
                  {q.question}
                </button>
              ))}
            </div>
          )}

          {/* Input */}
          <div style={styles.inputRow}>
            <input
              value={input}
              onChange={(e) => setInput(e.target.value)}
              placeholder={ui.inputPlaceholder}
              style={styles.input}
              onKeyDown={(e) => e.key === "Enter" && handleSend(input)}
            />
            <button
              onClick={() => handleSend(input)}
              style={{ ...styles.sendBtn, background: ui.accentColor }}
            >
              Send
            </button>
          </div>

          {/* Branding */}
          {!ui.hideBranding && ui.brandingImageURL && (
            <div style={styles.branding}>
              <span>Powered by</span>
              <img src={ui.brandingImageURL} style={styles.brandingImg} />
            </div>
          )}
        </div>
      )}
    </>
  );
}

const styles = {
  fab: {
    position: "fixed",
    bottom: 20,
    zIndex: 9999,
    padding: "12px 16px",
    borderRadius: 999,
    border: "none",
    color: "#fff",
    fontWeight: 600,
    cursor: "pointer",
  },
  container: {
    position: "fixed",
    bottom: 80,
    width: 360,
    height: 500,
    background: "#fff",
    borderRadius: 12,
    boxShadow: "0 10px 30px rgba(0,0,0,.25)",
    display: "flex",
    flexDirection: "column",
    overflow: "hidden",
    zIndex: 9999,
  },
  header: {
    padding: 12,
    color: "#fff",
    display: "flex",
    gap: 10,
    alignItems: "center",
  },
  botName: { fontWeight: 600 },
  subheading: { fontSize: 12, opacity: 0.9 },
  avatar: {
    width: 32,
    height: 32,
    borderRadius: "50%",
    objectFit: "cover",
  },
  messages: {
    flex: 1,
    padding: 12,
    overflowY: "auto",
    display: "flex",
    flexDirection: "column",
    gap: 8,
  },
  message: {
    maxWidth: "75%",
    padding: "8px 12px",
    borderRadius: 8,
    fontSize: 14,
  },
  starters: {
    padding: 8,
    display: "flex",
    gap: 6,
    flexWrap: "wrap",
    borderTop: "1px solid #e5e7eb",
  },
  starterChip: {
    padding: "6px 10px",
    borderRadius: 999,
    background: "#fff",
    border: "1px solid",
    cursor: "pointer",
    fontSize: 12,
  },
  inputRow: {
    display: "flex",
    padding: 8,
    gap: 8,
    borderTop: "1px solid #e5e7eb",
  },
  input: {
    flex: 1,
    padding: 8,
    borderRadius: 6,
    border: "1px solid #d1d5db",
  },
  sendBtn: {
    padding: "8px 14px",
    borderRadius: 6,
    border: "none",
    color: "#fff",
    cursor: "pointer",
  },
  typing: {
    fontSize: 12,
    color: "#6b7280",
  },
  branding: {
    display: "flex",
    gap: 6,
    alignItems: "center",
    justifyContent: "center",
    padding: 6,
    borderTop: "1px solid #e5e7eb",
    fontSize: 11,
  },
  brandingImg: {
    maxHeight: 14,
  },
};
`;
  };



  const codeScrollStyle = {
    margin: 0,
    padding: 16,
    overflow: "auto",
    maxHeight: 420,
    fontFamily: "ui-monospace, SFMono-Regular, Menlo, monospace",
    fontSize: 13,
    background: "#0a0a0a",
    color: "#e5e7eb",
    borderRadius: 8
  };

  function useIsMobile(breakpoint = 768) {
    const [isMobile, setIsMobile] = React.useState(
      typeof window !== "undefined" ? window.innerWidth < breakpoint : false
    );

    React.useEffect(() => {
      const onResize = () => setIsMobile(window.innerWidth < breakpoint);
      window.addEventListener("resize", onResize);
      return () => window.removeEventListener("resize", onResize);
    }, [breakpoint]);

    // (optional) also gate by UA to catch narrow desktop windows if you want:
    // const uaMobile = /Mobi|Android|iPhone|iPad|iPod/i.test(navigator.userAgent);
    // return isMobile || uaMobile;

    return isMobile;
  }
  const isMobile = useIsMobile(768);

  // ...
  if (isMobile) {
    return (
      <div className="mobile-blocker">
        <img
          src={mobilePhoto}  // or: import img from '../assets/...'; and use {img}
          alt="Feature unavailable on mobile"
          className="mobile-blocker__img"
        />
        <h2>This feature isn't available on mobile right now.</h2>
        <p>Get the full experience on desktop. Thank you for your understanding!</p>
      </div>
    );
  }

  // OLD:
  // if (!bot) return <p>Loading...</p>;

  // NEW:
  if (!bot) return <BotDetailsSkeleton />;

  const uploadToCloudinary = async (file, folder) => {
    const cloudName = "duzxrffoe";
    const uploadPreset = "XenaChat";

    const data = new FormData();
    data.append("file", file);
    data.append("upload_preset", uploadPreset);
    data.append("folder", folder);

    const res = await fetch(
      `https://api.cloudinary.com/v1_1/${cloudName}/image/upload`,
      { method: "POST", body: data }
    );

    const json = await res.json();
    if (!json.secure_url) throw new Error("Upload failed");
    return json.secure_url;
  };

  const uploadBrandingLogoToCloudinary = async () => {
    const cloudName = "duzxrffoe";
    const uploadPreset = "XenaChat";

    const res = await fetch(xenaChatLogo);
    const blob = await res.blob();

    const formData = new FormData();
    formData.append("file", blob);
    formData.append("upload_preset", uploadPreset);
    formData.append("folder", "xenachat/branding");

    const uploadRes = await fetch(
      `https://api.cloudinary.com/v1_1/${cloudName}/image/upload`,
      {
        method: "POST",
        body: formData,
      }
    );

    const json = await uploadRes.json();
    if (!json.secure_url) {
      throw new Error("Branding logo upload failed");
    }

    return json.secure_url;
  };

  const canHideBranding = user?.managePlanAddOns?.dummyFlagPayment === true && user?.managePlanAddOns?.isHideBranding === true;

  const handleHelpCenterNavigation = () => {
    navigate("/dashboard", { state: { section: "Help" } });
  };

  return (
    <div className="bot-page">
      <aside className="bot-sidebar">
        <h2 className="bot-sidebar-logo">{bot.botName}</h2>
        <ul className="bot-sidebar-menu">
          <li onClick={() => setTrainingOpen(!trainingOpen)}>
            <span>Training</span>
          </li>

          {trainingOpen && (
            <ul className="nested-menu">
              <li className={selectedSection === "Sources" ? "active" : ""}
                onClick={() => setSelectedSection("Sources")}>Sources</li>
              {/* <li>Guidelines</li>
            <li>Workflows</li>
            <li>Actions</li> */}
            </ul>
          )}


          <li className={selectedSection === "Settings" ? "active" : ""} onClick={() => setSelectedSection("Settings")}><MdSettings /> Settings</li>
          <li className={selectedSection === "Integrations" ? "active" : ""} onClick={() => setSelectedSection("Integrations")}><MdOutlineIntegrationInstructions /> Integrations</li>

          <li className={selectedSection === "Connect" ? "active" : ""} onClick={() => setSelectedSection("Connect")}><FaLink /> Connect</li>
          <li
            className={selectedSection === "Inbox" ? "active" : ""}
            onClick={() => setSelectedSection("Inbox")}
          >
            <FaInbox /> Inbox
          </li>

          <li className={selectedSection === "Analytics" ? "active" : ""} onClick={() => setSelectedSection("Analytics")}><FaChartBar /> Analytics</li>
          <li onClick={handleHelpCenterNavigation}><FaQuestionCircle /> Help Center</li>
          <li onClick={() => navigate(`/bot/${botId}/bookdemo`)}>
            <FaHeadset /> Contact Sales
          </li>

        </ul>
      </aside>

      <main className="bot-details-container">
        <ToastContainer
          position="top-right"
          autoClose={2500}
          hideProgressBar={false}
          newestOnTop
          closeOnClick
          pauseOnFocusLoss
          pauseOnHover
        />

        {selectedSection === "Settings" && (
          <>
            <div className="settings-header">
              <h2>Settings</h2>
            </div>

            <div className="settings-body">
              <aside className="settings-sidebar">
                <ul>
                  {["General", "Appearance", "Messaging", "Starter questions", "Email setup", "Usage and security", "User form", "Working hours"].map((tab) => (
                    <li
                      key={tab}
                      className={settingsTab === tab ? "active" : ""}
                      onClick={() => setSettingsTab(tab)}
                    >
                      {tab}
                    </li>
                  ))}
                </ul>
              </aside>

              <section className="settings-content">

                {settingsTab === "General" && (
                  <>
                    <h3>Configure your bot according to your needs</h3>
                    <label htmlFor="botName">Bot name</label>
                    <input
                      type="text"
                      id="botName"
                      value={bot.botName}
                      onChange={(e) => setBot({ ...bot, botName: e.target.value })}
                      placeholder="Give your bot a friendly name"
                    />

                    <label htmlFor="description">Description</label>
                    <textarea
                      id="description"
                      rows={3}
                      value={bot.description || ""}
                      onChange={(e) => setBot({ ...bot, description: e.target.value })}
                      placeholder="Bot description for internal references"
                    />


                  </>
                )}
                {settingsTab === "Appearance" && (
                  <div className="appearance-settings">
                    <h3>Customize the appearance of your bot as per your needs</h3>

                    <label>Bot name on the widget</label>
                    <input
                      type="text"
                      value={bot.widgetName || ''}
                      onChange={(e) => setBot({ ...bot, widgetName: e.target.value })}
                      placeholder="Bot name to be displayed in the chatbot"
                    />

                    <label>Subheading (optional)</label>
                    <input
                      type="text"
                      value={bot.subheading || ''}
                      onChange={(e) => setBot({ ...bot, subheading: e.target.value })}
                      placeholder="Displayed in the chatbot"
                    />

                    <div className="upload-section">
                      <div>
                        <label>XenaChat branding on the widget</label>

                        <img
                          src={xenaChatLogo}
                          alt="XenaChat branding"
                          style={{
                            width: 48,
                            marginTop: 8,
                            borderRadius: 6,
                            border: "1px solid #e5e7eb",
                            padding: 4,
                            background: "#fff",
                          }}
                        />

                        <p className="hint">
                          Official XenaChat branding is applied automatically.
                        </p>
                      </div>

                      <div>
                        <label>Bot Avatar</label>

                        {/* Show existing avatar if present */}
                        {bot.botAvatarURL && (
                          <div style={{ marginTop: 8 }}>
                            <p className="hint">Current avatar</p>
                            <img
                              src={bot.botAvatarURL}
                              alt="Current bot avatar"
                              style={{
                                width: 64,
                                height: 64,
                                borderRadius: "50%",
                                objectFit: "cover",
                                border: "1px solid #e5e7eb",
                                background: "#fff",
                              }}
                            />
                          </div>
                        )}

                        <p className="hint" style={{ marginTop: 8 }}>
                          If you want to change avatar then:
                        </p>

                        <input
                          type="file"
                          accept=".jpg,.png,.webp,.svg"
                          onChange={async (e) => {
                            const file = e.target.files?.[0];
                            if (!file) return;

                            const url = await uploadToCloudinary(file, "xenachat/avatars");
                            setBot(prev => ({ ...prev, botAvatarURL: url }));
                          }}
                        />
                      </div>
                    </div>

                    <label>Accent Colour</label>
                    <div className="color-palette">
                      {['#eb5757', '#f2994a', '#f2c94c', '#6fcf97', '#56ccf2', '#2d9cdb', '#9b51e0', '#f299ca', '#fff', '#1abc9c'].map(color => (
                        <div
                          key={color}
                          className={`color-dot ${bot.accentColor === color ? "selected" : ""}`}
                          style={{ backgroundColor: color }}
                          onClick={() => setBot({ ...bot, accentColor: color })}
                        />
                      ))}
                    </div>
                    <div className="form-section">
                      <label>Widget icon</label>
                      <div className="widget-icons">
                        {widgetIcons.map(({ icon, key }) => (
                          <div
                            key={key}
                            className={`icon-box ${bot.widgetIcon === key ? "selected" : ""}`}
                            onClick={() => setBot({ ...bot, widgetIcon: key })}
                          >
                            {icon}
                          </div>
                        ))}
                      </div>
                    </div>

                    {/* Widget Position */}
                    <div className="form-section">
                      <label>Widget position</label>
                      <p className="hint">Choose the location of the widget <br />Note: Doesn't work on the preview shown on this page</p>
                      <div className="widget-position">
                        <div
                          className={`position-box ${bot.widgetPosition === "left" ? "selected" : ""}`}
                          onClick={() => setBot({ ...bot, widgetPosition: "left" })}
                        >
                          <div className="grey-block left" />
                          <span>Left</span>
                        </div>
                        <div
                          className={`position-box ${bot.widgetPosition === "right" ? "selected" : ""}`}
                          onClick={() => setBot({ ...bot, widgetPosition: "right" })}
                        >
                          <div className="grey-block right" />
                          <span>Right</span>
                        </div>
                      </div>
                    </div>

                    {/* Input Placeholder */}
                    <div className="form-section">
                      <label htmlFor="inputPlaceholder">Input Placeholder</label>
                      <input
                        type="text"
                        id="inputPlaceholder"
                        value={bot.inputPlaceholder || ""}
                        onChange={(e) => setBot({ ...bot, inputPlaceholder: e.target.value })}
                        placeholder="Enter chat input placeholder"
                      />
                    </div>

                    {/* Branding Toggle */}
                    <div className="form-section toggle-section">
                      <label>XenaChat branding on the widget</label>
                      <div className="branding-toggle-row">
                        <span>Hide/Show XenaChat banner at the bottom</span>
                        <label className="switch">
                          <input
                            type="checkbox"
                            checked={canHideBranding ? bot.hideBranding : false}
                            disabled={!canHideBranding}
                            onChange={(e) =>
                              setBot({ ...bot, hideBranding: e.target.checked })
                            }
                          />
                          <span className="slider round"></span>
                        </label>
                      </div>
                      {!canHideBranding && (
                        <p className="hint" style={{ marginTop: 6 }}>
                          Enable <strong>Hide Branding</strong> from <strong>Manage Plan</strong> to remove XenaChat branding.
                        </p>
                      )}
                    </div>
                    <div className="form-section toggle-section">
                      <label>Widget is open by default</label>
                      <div className="branding-toggle-row">
                        <span>Open/Close widget when user engage for the first time</span>
                        <label className="switch">
                          <input
                            type="checkbox"
                            checked={bot.isWidgetOpen}
                            onChange={(e) =>
                              setBot({ ...bot, isWidgetOpen: e.target.checked })
                            }
                          />
                          <span className="slider round"></span>
                        </label>
                      </div>
                    </div>

                    <div className="form-section toggle-section">
                      <label>Starter Questions</label>
                      <div className="branding-toggle-row">
                        <span>Show floating Starter Questions</span>
                        <label className="switch">
                          <input
                            type="checkbox"
                            checked={bot.showStarterQuestions}
                            onChange={(e) =>
                              setBot({ ...bot, showStarterQuestions: e.target.checked })
                            }
                          />
                          <span className="slider round"></span>
                        </label>
                      </div>
                    </div>

                  </div>
                )}
                {settingsTab === "Messaging" && (
                  <div className="messaging-settings">
                    <h3>Customize and fine-tune the message settings of your bot</h3>

                    <div className="messaging-row">
                      <label>AI Model</label>

                      <select
                        className="messaging-model-select"
                        value={bot.aiModel || "gpt-4o-mini"}
                        onChange={(e) => setBot({ ...bot, aiModel: e.target.value })}
                        disabled={!hasAnyPlan}   // ❌ no plan → cannot change model
                        title={
                          !hasAnyPlan
                            ? "Select a paid plan to customize the AI model."
                            : currentPlanKey === "starter"
                              ? "Starter plan: GPT-4o mini only. Upgrade for more models."
                              : undefined
                        }
                      >
                        {effectiveAIModels.map((m) => (
                          <option key={m.id} value={m.id}>
                            {m.label}
                          </option>
                        ))}
                      </select>

                      {/* Small helper text under the dropdown */}
                      {!hasAnyPlan && (
                        <p className="plan-hint">
                          You’re on the free tier. Choose Starter, Professional or Advanced in Billing to unlock AI model selection.
                        </p>
                      )}

                      {currentPlanKey === "starter" && (
                        <p className="plan-hint">
                          Starter plan includes <strong>GPT-4o mini</strong>. Upgrade to Professional to access GPT-4 and latest models.
                        </p>
                      )}

                      {currentPlanKey === "pro" && (
                        <p className="plan-hint">
                          Professional plan lets you use <strong>GPT-4</strong> and our latest AI models.
                        </p>
                      )}

                      {currentPlanKey === "advanced" && (
                        <p className="plan-hint">
                          Advanced plan unlocks <strong>industry-specific agentic workflows</strong> with AI agents that reason and
                          execute tasks automatically.
                        </p>
                      )}
                    </div>



                    <div className="messaging-toggle">
                      <div>
                        <strong>Conversational Mode</strong>
                        <span className="messaging-badge">New</span>
                        <p>Segment bot's responses into shorter, more readable messages</p>
                      </div>
                      <label className="switch">
                        <input type="checkbox" checked={bot.conversationalMode} onChange={(e) => setBot({ ...bot, conversationalMode: e.target.checked })} />
                        <span className="slider round" />
                      </label>
                    </div>

                    <div className="messaging-toggle">
                      <div>
                        <strong>Strict FAQ Responses</strong>
                        <span className="messaging-badge">New</span>
                        <p>When enabled, responses are limited to exact FAQ content.</p>
                      </div>
                      <label className="switch">
                        <input type="checkbox" checked={bot.strictFaq} onChange={(e) => setBot({ ...bot, strictFaq: e.target.checked })} />
                        <span className="slider round" />
                      </label>
                    </div>

                    <div className="messaging-toggle">
                      <div>
                        <strong>Response Length</strong>
                        <p>Select the response length of your bot</p>
                      </div>
                      <select value={bot.responseLength} onChange={(e) => setBot({ ...bot, responseLength: e.target.value })}>
                        <option value="short">Short</option>
                        <option value="long">Long</option>
                      </select>
                    </div>

                    {toggleSettings.map((item) => (
                      <div key={item.key} className="messaging-toggle">
                        <div>
                          <strong>{item.label}</strong>
                          <p className="messaging-description">{item.value}</p>
                        </div>
                        <label className="switch">
                          <input
                            type="checkbox"
                            checked={bot[item.key]}
                            onChange={(e) => setBot({ ...bot, [item.key]: e.target.checked })}
                          />
                          <span className="slider round" />
                        </label>
                      </div>
                    ))}


                    <div className="messaging-message">
                      <label>Welcome Message</label>
                      <input
                        type="text"
                        value={bot.welcomeMessage || ""}
                        onChange={(e) => setBot({ ...bot, welcomeMessage: e.target.value })}
                        placeholder="Hey there, how can I help you?"
                      />

                      <label>Message shown when no Source is added</label>
                      <input
                        type="text"
                        value={bot.noSourceMessage || ""}
                        onChange={(e) => setBot({ ...bot, noSourceMessage: e.target.value })}
                        placeholder="The bot is yet to be trained..."
                      />

                      <label>Message shown when there is a Server Error</label>
                      <input
                        type="text"
                        value={bot.serverErrorMessage || ""}
                        onChange={(e) => setBot({ ...bot, serverErrorMessage: e.target.value })}
                        placeholder="Apologies, there seems to be a server error."
                      />
                    </div>
                  </div>
                )}
                {settingsTab === "Starter questions" && (
                  <div className="starter-questions-container">
                    <h3>
                      These will be shown upfront to your user as nudges. You can style the
                      answers using markdown.
                    </h3>

                    {starterQuestions.length > 0 && (
                      <DragDropContext onDragEnd={handleDragEnd}>
                        <Droppable droppableId="starterQuestions">
                          {(provided) => (
                            <div
                              className="starter-question-list"
                              {...provided.droppableProps}
                              ref={provided.innerRef}
                            >
                              {starterQuestions.map((item, index) => (
                                <Draggable
                                  key={index}
                                  draggableId={`question-${index}`}
                                  index={index}
                                >
                                  {(provided) => (
                                    <div
                                      className="starter-question-card"
                                      ref={provided.innerRef}
                                      {...provided.draggableProps}
                                    >
                                      <div className="drag-icon" {...provided.dragHandleProps}>
                                        <FiMove />
                                      </div>

                                      <div className="qa-content">
                                        <strong>{item.question}</strong>
                                        <p>{item.answer}</p>
                                      </div>

                                      {/* 🔽 Actions: Edit + Delete */}
                                      <div className="menu-icon">
                                        <button
                                          className="icon-button"
                                          type="button"
                                          onClick={() => {
                                            setIsAddingQuestion(true);
                                            setEditIndex(index);
                                            setNewQuestion(item.question);
                                            setNewAnswer(item.answer);
                                          }}
                                          title="Edit"
                                        >
                                          <FiEdit2 />
                                        </button>
                                        <button
                                          className="icon-button"
                                          type="button"
                                          onClick={() => {
                                            const updated = starterQuestions.filter(
                                              (_q, i) => i !== index
                                            );
                                            setStarterQuestions(updated);
                                            setBot({ ...bot, starterQuestions: updated });
                                            // If deleting the one we were editing, reset form
                                            if (editIndex === index) {
                                              setEditIndex(null);
                                              setNewQuestion("");
                                              setNewAnswer("");
                                              setIsAddingQuestion(false);
                                            }
                                          }}
                                          title="Delete"
                                        >
                                          <FiTrash2 />
                                        </button>
                                      </div>
                                    </div>
                                  )}
                                </Draggable>
                              ))}
                              {provided.placeholder}
                            </div>
                          )}
                        </Droppable>
                      </DragDropContext>
                    )}

                    {/* Show only the form OR the "Add new" button */}
                    {isAddingQuestion ? (
                      <div className="starter-question-form">
                        <h4>{editIndex !== null ? "Edit starter question" : "Add starter question"}</h4>

                        <label>Question</label>
                        <input
                          type="text"
                          value={newQuestion}
                          onChange={(e) => setNewQuestion(e.target.value)}
                        />

                        <label>Answer</label>
                        <textarea
                          rows={2}
                          value={newAnswer}
                          onChange={(e) => setNewAnswer(e.target.value)}
                        />

                        <div className="form-actions">
                          <button
                            type="button"
                            onClick={() => {
                              setIsAddingQuestion(false);
                              setEditIndex(null);
                              setNewQuestion("");
                              setNewAnswer("");
                            }}
                          >
                            Cancel
                          </button>
                          <button
                            type="button"
                            onClick={() => {
                              if (!newQuestion.trim() || !newAnswer.trim()) return;

                              let updated = [...starterQuestions];

                              if (editIndex !== null) {
                                // 🔁 Edit existing question
                                updated[editIndex] = {
                                  question: newQuestion,
                                  answer: newAnswer,
                                };
                              } else {
                                // ➕ Add new question
                                updated = [
                                  ...starterQuestions,
                                  { question: newQuestion, answer: newAnswer },
                                ];
                              }

                              setStarterQuestions(updated);
                              setBot({ ...bot, starterQuestions: updated });
                              setNewQuestion("");
                              setNewAnswer("");
                              setIsAddingQuestion(false);
                              setEditIndex(null);
                            }}
                          >
                            Save
                          </button>
                        </div>
                      </div>
                    ) : (
                      <button
                        className="add-question-btn"
                        type="button"
                        onClick={() => {
                          setIsAddingQuestion(true);
                          setEditIndex(null);
                          setNewQuestion("");
                          setNewAnswer("");
                        }}
                      >
                        <FiPlus /> Add new Starter question
                      </button>
                    )}

                    {/* Show warning only if more than 3 questions */}
                    {starterQuestions.length > 3 && (
                      <div className="starter-warning">
                        <span>⚠️</span> The widget seems a little cluttered. We recommend you
                        don't show more than 3–4 questions.
                      </div>
                    )}
                  </div>
                )}

                {settingsTab === "Email setup" && (
                  <div className="email-setup-container">
                    <h3>Set up email for transcript and support purposes</h3>

                    {/* Toggle: send transcript */}
                    <div className="email-setup-row">
                      <label>Send Email Transcript</label>
                      <p>
                        If enabled, we email users their respective chat transcript after the chat has ended
                      </p>
                      <label className="switch">
                        <input
                          type="checkbox"
                          checked={!!bot.sendEmailTranscript}
                          onChange={(e) =>
                            setBot({ ...bot, sendEmailTranscript: e.target.checked })
                          }
                        />
                        <span className="slider round"></span>
                      </label>
                    </div>

                    {/* Main support email */}
                    <div className="email-setup-input">
                      <label>Main customer support email address</label>
                      <p>General email address for any case</p>
                      <input
                        type="email"
                        value={bot.supportEmail || ""}
                        onChange={(e) => setBot({ ...bot, supportEmail: e.target.value })}
                        placeholder="support@example.com"
                      />
                    </div>

                    {/* Extra support emails with full CRUD */}
                    <div className="email-setup-input">
                      <label>Add Support emails</label>
                      <p>Automatically redirect specific issues to relevant emails</p>

                      {/* Existing entries */}
                      {supportRoutes.length > 0 && (
                        <div className="support-email-list">
                          {supportRoutes.map((route, idx) => (
                            <div key={idx} className="support-email-row">
                              <input
                                type="text"
                                placeholder="Label (e.g. Billing, Sales)"
                                value={route.label || ""}
                                onChange={(e) => {
                                  const updated = [...supportRoutes];
                                  updated[idx] = { ...updated[idx], label: e.target.value };
                                  syncSupportRoutes(updated);
                                }}
                              />
                              <input
                                type="email"
                                placeholder="email@company.com"
                                value={route.email || ""}
                                onChange={(e) => {
                                  const updated = [...supportRoutes];
                                  updated[idx] = { ...updated[idx], email: e.target.value };
                                  syncSupportRoutes(updated);
                                }}
                              />
                              <button
                                type="button"
                                className="support-email-remove"
                                onClick={() => {
                                  const updated = supportRoutes.filter((_, i) => i !== idx);
                                  syncSupportRoutes(updated);
                                }}
                              >
                                Remove
                              </button>
                            </div>
                          ))}
                        </div>
                      )}

                      {/* Add new */}
                      <button
                        type="button"
                        className="add-support-email-btn"
                        onClick={() => {
                          const updated = [
                            ...supportRoutes,
                            { label: "", email: "" },
                          ];
                          syncSupportRoutes(updated);
                        }}
                      >
                        <span className="plus-icon">+</span> Add new
                      </button>
                    </div>
                  </div>
                )}


                {settingsTab === "Usage and security" && (
                  <div className="usage-security-container">
                    <h3>Manage usage and security for your bot</h3>

                    <div className="usage-limit-section">
                      <label>Usage limit per user</label>
                      <p>
                        Limit the number of messages per user to avoid misuse. This applies to both, the widget, and
                        messaging apps like WhatsApp, Messenger and Telegram.
                      </p>
                      <div className="usage-limit-input-row">
                        <input
                          type="number"
                          value={bot.messageLimit || ""}
                          onChange={(e) => setBot({ ...bot, messageLimit: e.target.value })}
                          min={1}
                        />
                        <span className="usage-limit-label">Messages per user</span>
                        <select
                          value={bot.limitType || "per day"}
                          onChange={(e) => setBot({ ...bot, limitType: e.target.value })}
                        >
                          <option value="per hour">per hour</option>
                          <option value="per day">per day</option>
                          <option value="per week">per week</option>
                        </select>
                      </div>
                    </div>

                    <div className="usage-limit-section">
                      <label>User limit warning</label>
                      <p>Set warning message to show when user limit exceeds</p>
                      <input
                        type="text"
                        value={bot.limitWarning || ""}
                        onChange={(e) => setBot({ ...bot, limitWarning: e.target.value })}
                      />
                    </div>

                    <div className="usage-limit-section">
                      <label>Configure Bot rate limit</label>
                      <p>Set API rate limit per minute. Maximum rate limit is 300 per minute.</p>
                      <input
                        type="number"
                        value={bot.rateLimit || ""}
                        onChange={(e) => setBot({ ...bot, rateLimit: e.target.value })}
                        max={300}
                      />
                    </div>

                    <div className="usage-limit-section">
                      <label>Access for users with Masked IPs</label>
                      <p>Block users with masked IPs from accessing the chatbot</p>
                      <label className="switch">
                        <input
                          type="checkbox"
                          checked={bot.blockMaskedIPs}
                          onChange={(e) => setBot({ ...bot, blockMaskedIPs: e.target.checked })}
                        />
                        <span className="slider round"></span>
                      </label>
                    </div>
                  </div>
                )}
                {settingsTab === "User form" && (
                  <div className="user-form-settings">
                    <h3>Choose what data to collect from your users before they chat</h3>


                    {/* Toggles */}
                    <div className="form-toggle-row">
                      <div className="form-toggle-column">
                        <div className="form-toggle">
                          <label>Enable user form</label>
                          <p>Enable or disable user form</p>

                        </div>
                        <label className="switch">
                          <input
                            type="checkbox"
                            checked={bot.enableUserForm}
                            onChange={(e) => setBot({ ...bot, enableUserForm: e.target.checked })}
                          />
                          <span className="slider round"></span>
                        </label>
                      </div>

                      <div className="form-toggle-column">
                        <div className="form-toggle">
                          <label>Enable Captcha</label>
                          <p>Prevent automated spam and fraudulent activities</p>

                        </div>
                        <label className="switch">
                          <input
                            type="checkbox"
                            checked={bot.enableCaptcha}
                            onChange={(e) => setBot({ ...bot, enableCaptcha: e.target.checked })}
                          />
                          <span className="slider round"></span>
                        </label>
                      </div>


                    </div>

                    {/* Field Builder */}
                    {(!bot.userFormFields || bot.userFormFields.length === 0) ? (
                      <div className="no-fields-msg">
                        <button className="add-new-btn" onClick={() =>
                          setBot({
                            ...bot,
                            userFormFields: [{ type: "Text", label: "", required: false }]
                          })
                        }>
                          <FiPlus /> Add question
                        </button>
                      </div>
                    ) : (
                      <div className="form-builder">
                        {bot.userFormFields.map((field, idx) => (
                          <div key={idx} className="form-field-row">
                            <select
                              value={field.type}
                              onChange={(e) => {
                                const updatedFields = [...bot.userFormFields];
                                updatedFields[idx].type = e.target.value;
                                setBot({ ...bot, userFormFields: updatedFields });
                              }}
                            >
                              <option value="Text">Text</option>
                              <option value="Email">Email</option>
                              <option value="Phone">Phone</option>
                              <option value="Textarea">Textarea</option>
                            </select>
                            <input
                              type="text"
                              value={field.label}
                              onChange={(e) => {
                                const updatedFields = [...bot.userFormFields];
                                updatedFields[idx].label = e.target.value;
                                setBot({ ...bot, userFormFields: updatedFields });
                              }}
                              placeholder="Field label"
                            />
                            <label className="checkbox-label">
                              <input
                                type="checkbox"
                                checked={field.required}
                                onChange={(e) => {
                                  const updatedFields = [...bot.userFormFields];
                                  updatedFields[idx].required = e.target.checked;
                                  setBot({ ...bot, userFormFields: updatedFields });
                                }}
                              />
                              Required
                            </label>
                            <button
                              className="delete-btn"
                              onClick={() => {
                                const updatedFields = bot.userFormFields.filter((_, i) => i !== idx);
                                setBot({ ...bot, userFormFields: updatedFields });
                              }}
                            >
                              🗑️
                            </button>
                          </div>
                        ))}

                        <button
                          className="add-new-btn"
                          onClick={() =>
                            setBot({
                              ...bot,
                              userFormFields: [
                                ...bot.userFormFields,
                                { type: "Text", label: "", required: false },
                              ],
                            })
                          }
                        >
                          <FiPlus /> Add new
                        </button>
                      </div>
                    )}
                  </div>

                )}
                {settingsTab === "Working hours" && (
                  <div
                    className={`working-hours-container ${!bot.enableWorkingHours ? "working-hours-disabled" : ""}`}>
                      <h3>Configure your bot's active hours</h3>
                    
                      <div className="working-tabs">
                        <button className={workingTab === "Details" ? "active" : ""} onClick={() => setWorkingTab("Details")}>
                          Details
                        </button>
                        <button
                          className={workingTab === "Away Message" ? "active" : ""} onClick={() => setWorkingTab("Away Message")}>
                          Away Message
                        </button>
                      </div>
                    
                      {workingTab === "Away Message" && (
                        <div className="away-message-section">
                          <label>Away Message</label>
                          <p className="hint">
                            This message will be shown when users try to chat outside working hours.
                          </p>
                          <textarea
                            disabled={!bot.enableWorkingHours}
                            rows={2}
                            value={bot.awayMessage || ""}
                            onChange={(e) =>
                              setBot({ ...bot, awayMessage: e.target.value })
                            }
                            placeholder="We are currently offline. Please leave your message, we will get back to you soon."
                          />
                        </div>
                      )}

                      {workingTab === "Details" && (
                        <>
                          <div className="toggle-row">
                            <label>Enable Working Hours</label>
                      
                            <label className="switch">
                              <input
                                type="checkbox"
                                checked={bot.enableWorkingHours || false}
                                onChange={(e) =>
                                  setBot({
                                    ...bot,
                                    enableWorkingHours: e.target.checked,
                                  })
                                }
                              />
                              <span className="slider round"></span>
                            </label>
                          </div>
                              
                          {bot.enableWorkingHours && (
                            <>
                              {/* Timezone */}
                              <div className="timezone-select">
                                <label>Select Timezone</label>
                          
                                <select
                                  value={bot.timezone || "Asia/Kolkata"}
                                  onChange={(e) =>
                                    setBot({ ...bot, timezone: e.target.value })
                                  }
                                >
                                  <option value="Asia/Kolkata">
                                    (GMT+5:30) India Standard Time
                                  </option>
                                  <option value="America/New_York">
                                    (GMT-4:00) Eastern Time
                                  </option>
                                  <option value="Europe/London">
                                    (GMT+1:00) British Summer Time
                                  </option>
                                  <option value="Asia/Dubai">
                                    (GMT+4:00) Gulf Standard Time
                                  </option>
                                </select>
                              </div>
                              {/* Working Hours Table */}
                              <div className="working-hours-table">
                                {[
                                  "Monday", "Tuesday", "Wednesday", "Thursday",
                                  "Friday", "Saturday", "Sunday"
                                ].map((day) => (
                                  <div className="working-day-row" key={day}>
                                    <div className="day-label">{day}</div>
                                
                                    <div className="time-range-inputs">
                                      <input
                                        type="time"
                                        value={bot.workingHours?.[day]?.from || ""}
                                        onChange={(e) =>
                                          setBot({
                                            ...bot,
                                            workingHours: {
                                              ...bot.workingHours,
                                              [day]: {
                                                ...bot.workingHours?.[day],
                                                from: e.target.value,
                                              },
                                            },
                                          })
                                        }
                                      />
                                      <span>to</span>
                                      
                                      <input
                                        type="time"
                                        value={bot.workingHours?.[day]?.to || ""}
                                        onChange={(e) =>
                                          setBot({
                                            ...bot,
                                            workingHours: {
                                              ...bot.workingHours,
                                              [day]: {
                                                ...bot.workingHours?.[day],
                                                to: e.target.value,
                                              },
                                            },
                                          })
                                        }
                                      />
                                    </div>
                                      
                                    <label className="switch">
                                      <input
                                        type="checkbox"
                                        checked={bot.workingHours?.[day]?.enabled || false}
                                        onChange={(e) =>
                                          setBot({
                                            ...bot,
                                            workingHours: {
                                              ...bot.workingHours,
                                              [day]: {
                                                ...bot.workingHours?.[day],
                                                enabled: e.target.checked,
                                              },
                                            },
                                          })
                                        }
                                      />
                                      <span className="slider round"></span>
                                    </label>
                                  </div>
                                ))}
                              </div>
                            </>
                          )}
                        </>
                      )}
                    </div>
                  )}


              </section>

            </div>
            <div className="settings-buttons">
              <button className="discard-btn" onClick={handleDiscard}>Discard changes</button>
              <button className="save-btn" onClick={handleSave}>Save changes</button>
            </div>
          </>
        )}

        {selectedSection === "Integrations" && (
          <>
            <IntegrationsSection bot={bot} />
          </>
        )}

        {selectedSection === "Connect" && (
          <div className="integrations-section">
            <h2>Connect</h2>
            <p style={{ color: "#6b7280", marginTop: 4 }}>
              Generate code snippets to embed this bot on any website.
            </p>

            {/* Tabs */}
            <div style={{ display: "flex", gap: 8, margin: "12px 0" }}>
              {["JavaScript", "iFrame", "REST API"].map((t) => (
                <button
                  key={t}
                  onClick={() => setEmbedTab(t)}
                  className={embedTab === t ? "active" : ""}
                  style={{
                    padding: "8px 12px",
                    borderRadius: 8,
                    border: "1px solid #d1d5db",
                    background: embedTab === t ? "#111827" : "#fff",
                    color: embedTab === t ? "#fff" : "#111",
                    cursor: "pointer",
                  }}
                >
                  {t}
                </button>
              ))}
            </div>

            {/* Code box (chatService.js for REST API) */}
            <div
              style={{
                position: "relative",
                border: "1px solid #e5e7eb",
                borderRadius: 10,
                background: "#0a0a0a",
                color: "#e5e7eb",
              }}
            >
              <pre style={codeScrollStyle}>
                {embedTab === "JavaScript"
                  ? genJsSnippet()
                  : embedTab === "iFrame"
                    ? genIframeSnippet()
                    : genChatServiceSnippet()}
              </pre>

              <button
                onClick={() =>
                  copyToClipboard(
                    embedTab === "JavaScript"
                      ? genJsSnippet()
                      : embedTab === "iFrame"
                        ? genIframeSnippet()
                        : genChatServiceSnippet()
                  )
                }
                style={{
                  position: "absolute",
                  top: 8,
                  right: 8,
                  padding: "6px 10px",
                  borderRadius: 6,
                  border: "1px solid #d1d5db",
                  background: "#fff",
                  color: "#111",
                  cursor: "pointer",
                }}
              >
                Copy
              </button>
            </div>

            {/* Show SimpleChatBot.jsx below ONLY for REST API */}
            {embedTab === "REST API" && (
              <div
                style={{
                  marginTop: 16,
                  padding: 12,
                  border: "1px solid #e5e7eb",
                  borderRadius: 10,
                  background: "#ffffff",
                  color: "#000000",
                }}
              >
                <p style={{ marginBottom: 8 }}>
                  Paste this file into your project as{" "}
                  <code>// src/components/SimpleChatBot.jsx</code>
                </p>

                <div style={{ position: "relative" }}>
                  <pre style={codeScrollStyle}>{genSimpleChatBotSnippet()}</pre>

                  <button
                    onClick={() => copyToClipboard(genSimpleChatBotSnippet())}
                    style={{
                      position: "absolute",
                      top: 8,
                      right: 8,
                      padding: "6px 10px",
                      borderRadius: 6,
                      border: "1px solid #d1d5db",
                      background: "#fff",
                      color: "#111",
                      cursor: "pointer",
                      fontSize: 12,
                    }}
                  >
                    Copy
                  </button>
                </div>

                <code style={{ display: "block", marginTop: 8 }}>
                  {`Now use it in your React app:
import SimpleChatBot from "./components/SimpleChatBot";`}
                </code>
              </div>
            )}

            {/* React usage note */}
            <p
              style={{
                marginTop: 12,
                fontSize: 16,
                color: "#6b7280",
                lineHeight: 1.5,
              }}
            >
              <strong>Using React?</strong> Don&apos;t paste the
              <code> &lt;script&gt;...&lt;/script&gt; </code>
              directly in JSX. Instead, put the copied code inside a{" "}
              <code>useEffect</code> that creates a{" "}
              <code>&lt;script&gt;</code> element, sets{" "}
              <code>script.innerHTML</code> to the snippet, and appends it to{" "}
              <code>document.body</code>.
            </p>
          </div>
        )}

        {selectedSection === "Sources" && (
          <>
            {console.log("apiBase passed to SourcesTrainer:", apiBase)}
            <SourcesTrainer
              apiBase={apiBase}
              email={bot?.email || connectEmail}
              botName={bot?.botName || connectBotName}
              planCharLimit={uploadCharLimit}
              onReindexed={() => toast.success("Training data saved and embeddings rebuilt.")}
            />
          </>
        )}

        {selectedSection === "Inbox" && (
          <Inbox apiBase={apiBase} email={bot?.email} botName={bot?.botName} />
        )}

        {selectedSection === "Analytics" && (
          <Analytics
            apiBase={apiBase}
            email={bot?.email || connectEmail}
            botName={bot?.botName || connectBotName}
            days={14}
          />
        )}
      </main>

    </div>
  );
};


export default BotDetails;